
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    value: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      selectedValue: this.value,
    }
  },
  computed: {
    ...mapGetters('sdagenda', ['sdagenda']),
  },
  watch: {
    selectedValue(newValue) {
      this.$emit('input', newValue)
    },
  },
  mounted() {
    this.verifysdagenda()
  },
  methods: {
    ...mapActions('sdagenda', ['verifysdagenda']),
  },
}
